import { useTareas } from "../context/TareasContext"

const StatusBadge = ({ status, size = "sm" }) => {
  const { estadosTareas } = useTareas()

  const estado = estadosTareas.find(e => e.name === status || e.id === status)
  const color = estado?.color || "#9CA3AF"

  const px = size === "xs" ? "px-1.5 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs"

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium whitespace-nowrap ${px}`}
      style={{ backgroundColor: `${color}18`, color }}
    >
      <span
        className="w-1.5 h-1.5 rounded-full flex-shrink-0"
        style={{ backgroundColor: color }}
      />
      {estado?.name || status || "Sin estado"}
    </span>
  )
}

export default StatusBadge
